const QUERIES = {
  htmlRecordTypes: {
    object: "RecordType",
    fields: ["Id", "DeveloperName", "Name"],
    where: "SobjectType = 'HTML_Report_vod__c' AND IsActive = true AND DeveloperName != 'Remote_Meeting_vod'"
  },
  htmlReport: {
    object: "HTML_Report_vod__c",
    fields: ["Id", "Name"],
    where: "Studio_ID_vod__c = "
  },
  htmlReportDeployments: {
    object: "HTML_Report_vod__c",
    fields: ["Id", "Name", "Studio_ID_vod__c"],
    where: "Studio_ID_vod__c IN "
  },
  profiles: {
    object: "Profile",
    fields: ["Id", "Name"]
  },
  objectRecordTypes: {
    object: "RecordType",
    fields: ["Id", "DeveloperName", "Name"],
    where: "IsActive = true AND SobjectType = '%obj_name%'"
  },
  organization: {
    object: "Organization",
    fields: ["Id", "IsSandbox", "Name"],
    where: "Id = '%id%'"
  }
};

export { QUERIES };
